import { render, staticRenderFns } from "./GradesMultiSelect.vue?vue&type=template&id=df00e2b2"
import script from "./GradesMultiSelect.vue?vue&type=script&lang=js"
export * from "./GradesMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports